'use client';

import { useState } from 'react';


interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({
  categories,
  activeCategory,
  onCategoryChange,
}: CategoryFilterProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  const handleCategoryClick = (category: string) => {
    if (!isHydrated) return;
    onCategoryChange(category);
  };

  return (
    <div className="flex flex-wrap gap-3">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => handleCategoryClick(category)}
          disabled={!isHydrated}
          className={`px-5 py-2.5 rounded-lg font-medium text-sm transition-all duration-250 disabled:opacity-50 ${
            activeCategory === category
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-muted text-text-primary hover:bg-primary/10 hover:text-primary'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
}